<script lang="ts">
  import { Icon } from '@shared/ui/icon';

  export let isUserBestBidder: boolean;
  export let bestBid: string | undefined;
  export let price: string;
</script>

<li class="list-none">
  <div class="text-default-900 dark:text-default-50 mb-1.5 flex items-center gap-2 text-base font-medium">
    {#if bestBid}
      <Icon name="auctions" width="{16}" height="{16}" classes="pt-[0.5px] pb-[1px]" />
    {/if}

    {#if isUserBestBidder}
      Your Bid
    {:else if bestBid}
      Last Bid
    {:else}
      Initial Price
    {/if}
  </div>

  <article class="flex items-center gap-1">
    <Icon name="usdc" width="{16}" height="{16}" classes="pt-[0.5px] pb-[1px]" />

    <div>
      <span class="text-base font-medium">
        {price}
      </span>

      <span class="text-sm font-medium leading-4">USDC</span>
    </div>
  </article>
</li>
